/**
 * 模組頁面代碼 :
 * 頁面說明 : Breadcrumb元件
 * @module features/main-frame/components/Breadcrumb.jsx
 */

// ----- import from base components -----
import React from 'react';

const Breadcrumb = ({ categoryName, pageName }) => {
    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li className="breadcrumb-item">
                    <svg className="nav__icon nav__icon--breadcrumb me-3" aria-hidden="true">
                        <use href="#ico-settings-01"></use>
                    </svg>
                    {categoryName}
                </li>
                <li className="breadcrumb-item active" aria-current="page">{pageName}</li>
            </ol>
        </nav>

    );
};

export default Breadcrumb;
